import { render, staticRenderFns } from "./ChainDetails.vue?vue&type=template&id=2fddb974&scoped=true&"
import script from "./ChainDetails.vue?vue&type=script&lang=ts&"
export * from "./ChainDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fddb974",
  null
  
)

export default component.exports